class ProfitCalculationClass {
    // before only calculate
    calculateArticleProfit(article) {
        if (article.priceNew) {
            article.grossProfitPercent = calculatGrossProfitPercentage(article);
            article.changePercent = calculateChangePercentage(article);
        } else {
            article.grossProfitPercent = null;
            article.changePercent = null;
        }
    }

    calculateArticleForecast(article) {
        if (
            article &&
            article.priceNew &&
            article.sellingPricePharmacy &&
            article.sellingCountPharmacy
        ) {
            return (article.priceNew - article.sellingPricePharmacy) * article.sellingCountPharmacy;
        } else {
            return 0;
        }
    }
}

function calculatGrossProfitPercentage(article) {
    return 100 - (article.buyingPricePharmacy * 100) / article.priceNew;
}

function calculateChangePercentage(article) {
    return article.sellingPricePharmacy
        ? (article.priceNew * 100) / article.sellingPricePharmacy - 100
        : (article.priceNew * 100) / article.recommendedSellingPrice - 100;
}

export default new ProfitCalculationClass();
